import * as React from 'react';

function SvgUnsorted(props) {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M7.68 3.335a.413.413 0 01.64 0l2.702 3.227c.24.286.045.733-.32.733H5.297c-.364 0-.559-.447-.32-.733L7.68 3.335zM8.32 13.78a.413.413 0 01-.64 0l-2.702-3.227c-.24-.286-.045-.733.32-.733h5.404c.365 0 .56.447.32.733L8.32 13.781z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgUnsorted;
